import { refreshToken } from '@/auth/authHandler'
import { getAuthService } from '@/auth/auth.service'

export const getParentAuthService = ($shipBobStore) => {
  const userDetails = $shipBobStore?.getters['user/getUser']
  const oneIdClaim = $shipBobStore?.getters['user/getOneIdClaim']

  const claim = JSON.stringify({
    fcid: null,
    lorg: oneIdClaim.Lorg,
    morg: oneIdClaim.Morg,
    perm: oneIdClaim.Perm,
    org_atts: oneIdClaim.org_atts
  })

  return {
    getToken: async () => {
      return await getAuthService().getToken()
    },
    renewToken: () => refreshToken(),
    getTokenClaims: () => {
      return {
        shipbob_user_id: userDetails?.id,
        shipbob_impersonating_user_id: userDetails?.impersonatedUserId,
        shipbob_role: `${userDetails?.role}`,
        oneid: claim,
        ...userDetails ?? {}
      }
    }
  }
}
